// src/components/ServicesISOStandards.js
import React from 'react';
import { Link } from 'react-router-dom';
import './ServicesISOStandards.css'; // खाली दिलेले CSS

const ServicesISOStandards = () => {
  const isoStandards = [
    {
      id: '9001',
      name: 'ISO 9001',
      title: 'गुणवत्ता व्यवस्थापन प्रणाली',
      desc: 'उत्पादन आणि सेवेची गुणवत्ता सुधारते',
      path: '/cert/iso9001'
    },
    {
      id: '27001',
      name: 'ISO 27001',
      title: 'माहिती सुरक्षा व्यवस्थापन',
      desc: 'डेटा आणि गोपनीयतेचे संरक्षण',
      path: '/cert/iso27001'
    },
    {
      id: '14001',
      name: 'ISO 14001',
      title: 'पर्यावरण व्यवस्थापन',
      desc: 'पर्यावरणावर सकारात्मक प्रभाव',
      path: '/cert/iso14001'
    },
    {
      id: '45001',
      name: 'ISO 45001',
      title: 'व्यावसायिक आरोग्य व सुरक्षा',
      desc: 'कर्मचाऱ्यांची सुरक्षा सुनिश्चित',
      path: '/cert/iso45001'
    },
    {
      id: '22000',
      name: 'ISO 22000',
      title: 'अन्न सुरक्षा व्यवस्थापन',
      desc: 'अन्न सुरक्षितता हमी',
      path: '/cert/iso22000'
    },
    {
      id: '21001',
      name: 'ISO 21001',
      title: 'शैक्षणिक संस्था व्यवस्थापन',
      desc: 'शिक्षणाची गुणवत्ता वाढवते',
      path: '/cert/iso21001'
    },
  ];

  return (
    <div className="services-iso-page">
      <section className="services-header">
        <h1>सेवा आणि ISO मानके</h1>
        <p className="subtitle">
          तुमच्या संस्थेसाठी योग्य ISO प्रमाणन निवडा आणि विश्वासार्हता वाढवा
        </p>
      </section>

      <section className="iso-grid">
        {isoStandards.map((std) => (
          <div key={std.id} className="iso-card">
            <div className="card-header">
              <h3>{std.name}</h3>
              <p className="card-title">{std.title}</p>
            </div>
            <p className="card-desc">{std.desc}</p>
            <div className="card-actions">
              <Link to={std.path} className="btn-know-more">
                जाणून घ्या
              </Link>
              <Link to={std.path} className="btn-apply">
                आजच अर्ज करा
              </Link>
            </div>
          </div>
        ))}
      </section>

      <section className="why-iso-section">
        <h2>ISO प्रमाणन का आवश्यक आहे?</h2>
        <ul className="why-list">
          <li>नागरिकांना चांगली सेवा मिळते (उदा. ग्रामपंचायत)</li>
          <li>कायदेशीर जबाबदारी पूर्ण होते</li>
          <li>संस्थेची विश्वासार्हता वाढते</li>
          <li>प्रक्रिया सुव्यवस्थित होतात</li>
          <li>ग्राहक समाधान वाढते</li>
        </ul>
        <div className="cta-box">
          <p><strong>आजच तपासणी यादी (Checklist) डाउनलोड करा!</strong></p>
          <a href="/checklist-iso.pdf" className="btn-download" download>
            डाउनलोड करा
          </a>
        </div>
      </section>
    </div>
  );
};

export default ServicesISOStandards;